import { useTranslation } from 'module/hooks/use-translation';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { Switcher } from 'module/ui/components/atoms/switcher/switcher';
import { faList, faGrid2 } from '@fortawesome/pro-regular-svg-icons';
import { RadioChangeEvent, Tooltip } from 'antd';
import { FC, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface ViewSwitcherProps {
  primaryPageUrl: string;
  secondaryPageUrl: string;
  primaryIcon?: React.ReactNode;
  secondaryIcon?: React.ReactNode;
  primaryViewName?: string;
  secondaryViewName?: string;
}

export const ViewSwitcher: FC<React.PropsWithChildren<ViewSwitcherProps>> = ({
  primaryPageUrl,
  secondaryPageUrl,
  primaryIcon,
  secondaryIcon,
  primaryViewName,
  secondaryViewName,
}) => {
  const { pathname, search } = useLocation();
  const push = useNavigate();
  const listViewName = useTranslation('list.view');
  const boardViewName = useTranslation('board.view');
  const onChange = useCallback(
    (e: RadioChangeEvent) => {
      if (e.target.value === pathname) {
        return;
      }

      push({
        pathname: e.target.value,
        search,
      });
    },
    [push, search, pathname],
  );

  return (
    <Switcher
      solid
      value={pathname}
      size="small"
      onChange={onChange}
      // activeColor="black"
    >
      <Tooltip title={primaryViewName || boardViewName} mouseEnterDelay={0.8}>
        <Switcher.Button
          id="switcher_board"
          value={primaryPageUrl}
          icon={primaryIcon || <FontAwesomeIcon icon={faGrid2} />}
          data-cy="all_tasks.switcher_board"
        />
      </Tooltip>
      <Tooltip title={secondaryViewName || listViewName} mouseEnterDelay={0.8}>
        <Switcher.Button
          id="switcher_list"
          value={secondaryPageUrl}
          icon={secondaryIcon || <FontAwesomeIcon icon={faList} />}
          data-cy="all_tasks.switcher_list"
        />
      </Tooltip>
    </Switcher>
  );
};
